import article8Slice from './article8Slice';

export { default as article8Op } from './operations';

export default article8Slice;
